import { render, staticRenderFns } from "./alertDetails.vue?vue&type=template&id=380dbe44&scoped=true&"
import script from "./alertDetails.vue?vue&type=script&lang=js&"
export * from "./alertDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380dbe44",
  null
  
)

export default component.exports